import { render, staticRenderFns } from "./colegios_libros.vue?vue&type=template&id=4371d391"
import script from "./colegios_libros.vue?vue&type=script&lang=js"
export * from "./colegios_libros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports